(function () {
  const ROOT = '[data-media-spotlight]';

  function setActive(root, mediaId) {
    root.querySelectorAll('[data-spotlight-item]').forEach(function (item) {
      const active = item.dataset.mediaId === mediaId;
      item.classList.toggle('is-active', active);
      if (!active) resetZoom(item);
    });

    root.querySelectorAll('[data-spotlight-thumb]').forEach(function (thumb) {
      const active = thumb.dataset.mediaId === mediaId;
      thumb.setAttribute('aria-current', active ? 'true' : 'false');
      if (active) {
        thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
    });
  }

  function resetZoom(item) {
    const image = item.querySelector('img');
    item.classList.remove('is-zooming');
    if (image) image.style.transformOrigin = '';
  }

  function trackZoom(item, event) {
    const image = item.querySelector('img');
    if (!image) return;

    const rect = item.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width) * 100;
    const y = ((event.clientY - rect.top) / rect.height) * 100;

    image.style.transformOrigin = Math.min(Math.max(x, 0), 100) + '% ' + Math.min(Math.max(y, 0), 100) + '%';
    item.classList.add('is-zooming');
  }

  function refreshNav(root) {
    const rail = root.querySelector('[data-spotlight-thumbs]');
    const prev = root.querySelector('[data-spotlight-prev]');
    const next = root.querySelector('[data-spotlight-next]');
    if (!rail || (!prev && !next)) return;

    const maxScroll = rail.scrollWidth - rail.clientWidth;
    const overflows = maxScroll > 1;

    [prev, next].forEach(function (button) {
      if (button) button.hidden = !overflows;
    });

    if (prev) prev.disabled = rail.scrollLeft <= 1;
    if (next) next.disabled = rail.scrollLeft >= maxScroll - 1;
  }

  function refreshAll() {
    document.querySelectorAll(ROOT).forEach(refreshNav);
  }

  document.addEventListener('click', function (event) {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const nav = target.closest('[data-spotlight-prev], [data-spotlight-next]');
    if (nav) {
      const root = nav.closest(ROOT);
      const rail = root && root.querySelector('[data-spotlight-thumbs]');
      if (!rail) return;

      event.preventDefault();
      const direction = nav.hasAttribute('data-spotlight-prev') ? -1 : 1;
      rail.scrollBy({ left: direction * rail.clientWidth * 0.8, behavior: 'smooth' });
      return;
    }

    const thumb = target.closest('[data-spotlight-thumb]');
    if (!thumb) return;

    const root = thumb.closest(ROOT);
    if (!root) return;

    event.preventDefault();
    setActive(root, thumb.dataset.mediaId);
  });

  document.addEventListener(
    'scroll',
    function (event) {
      const target = event.target instanceof Element ? event.target : null;
      if (!target || !target.matches('[data-spotlight-thumbs]')) return;
      const root = target.closest(ROOT);
      if (root) refreshNav(root);
    },
    { capture: true, passive: true }
  );

  window.addEventListener('resize', refreshAll, { passive: true });
  document.addEventListener('shopify:section:load', refreshAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAll);
  } else {
    refreshAll();
  }

  document.addEventListener(
    'pointermove',
    function (event) {
      if (event.pointerType !== 'mouse') return;

      const target = event.target instanceof Element ? event.target : null;
      const item = target && target.closest('[data-spotlight-item][data-zoomable]');
      if (!item || !item.classList.contains('is-active')) return;

      trackZoom(item, event);
    },
    { passive: true }
  );

  document.addEventListener(
    'pointerleave',
    function (event) {
      const target = event.target instanceof Element ? event.target : null;
      const item = target && target.closest ? target.closest('[data-spotlight-item][data-zoomable]') : null;
      if (item) resetZoom(item);
    },
    { capture: true, passive: true }
  );

  document.addEventListener('variant:update', function (event) {
    const detail = event.detail;
    const mediaId = detail && detail.resource && detail.resource.featured_media
      ? String(detail.resource.featured_media.id)
      : null;
    if (!mediaId) return;

    document.querySelectorAll(ROOT).forEach(function (root) {
      if (root.querySelector('[data-spotlight-item][data-media-id="' + mediaId + '"]')) {
        setActive(root, mediaId);
      }
    });
  });
})();
